(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fabre-catalogue"] && !Shopify.designMode) return;
  try {
    
for (const catalogue of document.querySelectorAll('.fc')) {
  const panel = catalogue.querySelector('.fc-filter-panel');
  if (window.matchMedia('(max-width:749px)').matches) panel.open = false;
  const form = catalogue.querySelector('#CatalogueFilters');
  catalogue.querySelector('select[name="sort_by"]').addEventListener('change', () => form.requestSubmit());
  form.addEventListener('submit', () => {
    for (const input of form.querySelectorAll('input[type="number"]')) if (input.value === '') input.disabled = true;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
